module.exports = __webpack_public_path__ + "ff38420b5f62637a9753f7cdeb9cd812.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/Slideshow_06.jpg
// module id = 626
// module chunks = 0